module.exports = __webpack_public_path__ + "img/banner02m.44421cd7.png";